export default __webpack_public_path__ + "static/media/logoMobile.3e2a042e.svg";